/**
 * Farm-scoped live overview (dashboard) path.
 * @param {string | null | undefined} farmId
 * @returns {string | null}
 */
export function getFarmOverviewPath(farmId) {
  if (!farmId) return null;
  return `/farms/${encodeURIComponent(String(farmId))}/overview`;
}
